/**
 * @license
 * Copyright (c) 2020 - 2023 Vaadin Ltd.
 * This program is available under Apache License Version 2.0, available at https://vaadin.com/license/
 */
const template = document.createElement('template');

template.innerHTML = `
  <style nonce=${window.DESCOPE_NONCE}>
    @font-face {
      font-family: 'vaadin-avatar-icons';
      src: url('` + __webpack_public_path__ + `fonts/font-1949233557.woff');
      font-weight: normal;
      font-style: normal;
    }
  </style>
`;

document.head.appendChild(template.content);
